import gsap from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(MorphSVGPlugin);
gsap.registerPlugin(ScrollTrigger);
const globalFacilitiesSections = document.querySelectorAll(
  "#global-facilities "
);
globalFacilitiesSections.forEach((section) => {
  const wrapper = section.querySelector("#global-facilities .sticky-wrapper");
  const facilityCards = section.querySelectorAll(".facility-card");
  const wrapperHeight = wrapper.getBoundingClientRect().height;

  const regionsData = [];
  const regions = section.querySelectorAll(".regions .region");
  regions.forEach((region) => {
    regionsData.push(region.querySelector("p").textContent);
    region.addEventListener("click", () => {
      const first = section.querySelector(
        `.facility-card[data-region="${region.dataset.region}"]`
      );
      
      // Get the absolute position of the card relative to the document
      const cardRect = first.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const cardAbsoluteTop = cardRect.top + scrollTop;
      
      // Account for sticky header (top-24 = 96px) plus some padding
      const offset = 225; // Adjust this value as needed for your sticky header height
      const targetScroll = cardAbsoluteTop - offset;
      console.log(targetScroll);
      gsap.to(window, {
        scrollTo: targetScroll,
        duration: 1,
        ease: "power2.inOut",
      });
    });
  });

  console.log(regionsData);
  let activeRegion = null;

  console.log(top, wrapperHeight);
  document.addEventListener("scroll", () => {
    const top = wrapper.getBoundingClientRect().top;
    if (top < 100 && top > -1 * wrapperHeight) {
      console.log("sticky");

      // Find the first facility card completely in viewport
      const firstCompletelyVisibleCard = Array.from(facilityCards).find(
        (card) => {
          const rect = card.getBoundingClientRect();
          return rect.top >= -50 && rect.bottom <= window.innerHeight;
        }
      );

      if (firstCompletelyVisibleCard) {
        regions.forEach((region) => {
          if (
            region.dataset.region === firstCompletelyVisibleCard.dataset.region
          ) {
            region.classList.remove("bg-white", "text-navy");
            region.classList.add(region.dataset.activeBg, "text-white");
          } else {
            region.classList.remove(region.dataset.activeBg, "text-white");
            region.classList.add("bg-white", "text-navy");
          }
        });
      }
    } else {
      console.log("not sticky");
    }
  });

  facilityCards.forEach((card) => {
    const tabs = card.querySelectorAll(".info-tabs .tab");
    const contents = card.querySelectorAll(".contents .content");
    const indicator = card.querySelector(".indicator");

    // Set initial height for active content
    contents.forEach((content, i) => {
      if (content.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });

    tabs.forEach((tab, j) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        contents.forEach((content) => {
          content.classList.remove("active");
          content.style.maxHeight = "0px";
        });
        contents[j].classList.add("active");
        contents[j].style.maxHeight = contents[j].scrollHeight + "px";
        // indicator.style.width = `${100 / tabs.length}%`;
        indicator.style.transform = `translateX(${j * 100}%) translateY(-50%)`;
      });
    });
  });
});
